webpackJsonp([217],{

/***/ 1324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersFreezeForm_vue__ = __webpack_require__(3096);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b224988_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersFreezeForm_vue__ = __webpack_require__(5815);
function injectStyle (ssrContext) {
  __webpack_require__(5809)
  __webpack_require__(5811)
  this["$style"] = __webpack_require__(5813)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b224988"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersFreezeForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b224988_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersFreezeForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1670:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export searchRules */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return searchMasRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return freezeFormRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return newUserConfigRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return newbieMissionConfigRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  call_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择沟通类型', 'integer'))],
  communicate_detail: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择记录详情', 'integer'))],
  record_detail: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择沟通详情', 'string'))],
  communicate_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择沟通方式', 'integer'))]

};

var searchMasRules = {
  type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择群发消息', 'integer'))],
  title: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入消息标题', 'string')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('长度在1到30个字符'), { min: 1, max: 30 })],
  content: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入消息内容', 'string')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('长度在1到300个字符'), { min: 1, max: 300 })]
};

var formRules = {
  cellphone: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入手机号', 'string'))]
};

var freezeFormRules = {
  freeze_status: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择封号状态', 'integer'))],
  freeze_reason: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择封号原因', 'integer'))],
  freeze_reason_desc: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入封号原因'))]

};

var newUserConfigRules = {
  condition_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择条件类型', 'string'))]
};

var newbieMissionConfigRules = {
  'watch_tutorial_video.video_url': [{ required: true, message: '请选择教程视频', trigger: 'change' }],
  'watch_tutorial_video.img_url': [{ required: true, message: '请上传教程视频封面', trigger: 'change' }],
  'finish_newbie_task.task_id': [{ required: true, message: '请选择一个新手任务', trigger: 'change' }]
};

/***/ }),

/***/ 3096:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__users_rules_js__ = __webpack_require__(1670);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      freezeFormRules: __WEBPACK_IMPORTED_MODULE_0__users_rules_js__["b" /* freezeFormRules */],
      form: {
        userid: this.$route.params.userid,
        freeze_status: null,
        freeze_reason: null,
        freeze_reason_desc: '',
        add_blacklist_idnum: false,
        add_blacklist_cellphone: false
      },
      options: {
        freeze_status: [{ label: '阶段封号', value: -1 }, { label: '永久封号', value: -2 }],
        freeze_reason: [{ label: '多账号', value: 1 }, { label: '非本人使用', value: 2 }, { label: '虚假提交', value: 3 }, { label: '账号异常', value: 4 }, { label: '恶意抢单', value: 5 }, { label: '态度恶劣', value: 6 }, { label: '本人申请', value: 7 }, { label: '其他', value: 99 }]
      },
      loading: false
    };
  },

  computed: {},
  watch: {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    onLoad: function onLoad() {},
    onReload: function onReload() {
      this.onLoad();
    },
    onSubmit: function onSubmit() {
      var _this = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          request.common('freezeUser', _this.form).then(function (res) {
            _this.$confirm(_this.$route.meta.title + '成功, 是否返回用户列表？', '提示', { type: 'success' }).then(function () {
              _this.$router.push({ path: '/users/table' });
            }, function () {
              _this.$refs.form.resetFields();
            });
          });
        } else {
          _this.$message.error('提交内容填写不正确！');
        }
      });
    }
  }
});

/***/ }),

/***/ 5809:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5810);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("c5434692", content, true, {});

/***/ }),

/***/ 5810:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"UsersFreezeForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5811:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5812);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("5811cf09", content, true, {});

/***/ }),

/***/ 5812:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".blacklist-checkboxes .el-checkbox[data-v-0b224988]{margin-right:20px}.blacklist-tips[data-v-0b224988]{margin-top:10px;margin-left:50px;padding-bottom:20px}.blacklist-tips .tip-item[data-v-0b224988]{color:#909399;font-size:12px;line-height:1.8;margin-bottom:4px}", "", {"version":3,"sources":["/workspace/src/views/users/pages/UsersFreezeForm.vue"],"names":[],"mappings":"AACA,oDAAoD,iBAAiB,CACpE,AACD,iCAAiC,gBAAgB,iBAAiB,mBAAmB,CACpF,AACD,2CAA2C,cAAc,eAAe,gBAAgB,iBAAiB,CACxG","file":"UsersFreezeForm.vue","sourcesContent":["\n.blacklist-checkboxes .el-checkbox[data-v-0b224988]{margin-right:20px\n}\n.blacklist-tips[data-v-0b224988]{margin-top:10px;margin-left:50px;padding-bottom:20px\n}\n.blacklist-tips .tip-item[data-v-0b224988]{color:#909399;font-size:12px;line-height:1.8;margin-bottom:4px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5813:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5814);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("13c913ad", content, true, {});

/***/ }),

/***/ 5814:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"UsersFreezeForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5815:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/users/table"}},[_vm._v("用户管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("封号")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.freezeFormRules,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"封号状态","prop":"freeze_status"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择"},model:{value:(_vm.form.freeze_status),callback:function ($$v) {_vm.$set(_vm.form, "freeze_status", $$v)},expression:"form.freeze_status"}},_vm._l((_vm.options.freeze_status),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"封号原因","prop":"freeze_reason"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择"},model:{value:(_vm.form.freeze_reason),callback:function ($$v) {_vm.$set(_vm.form, "freeze_reason", $$v)},expression:"form.freeze_reason"}},_vm._l((_vm.options.freeze_reason),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),(_vm.form.freeze_reason === 99)?_c('el-form-item',{attrs:{"label":"封号原因","prop":"freeze_reason_desc"}},[_c('el-input',{attrs:{"placeholder":"请输入封号原因"},model:{value:(_vm.form.freeze_reason_desc),callback:function ($$v) {_vm.$set(_vm.form, "freeze_reason_desc", $$v)},expression:"form.freeze_reason_desc"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"添加黑名单池"}},[_c('div',{staticClass:"blacklist-checkboxes"},[_c('el-checkbox',{model:{value:(_vm.form.add_blacklist_idnum),callback:function ($$v) {_vm.$set(_vm.form, "add_blacklist_idnum", $$v)},expression:"form.add_blacklist_idnum"}},[_vm._v("身份证")]),_vm._v(" "),_c('el-checkbox',{model:{value:(_vm.form.add_blacklist_cellphone),callback:function ($$v) {_vm.$set(_vm.form, "add_blacklist_cellphone", $$v)},expression:"form.add_blacklist_cellphone"}},[_vm._v("手机号")])],1)]),_vm._v(" "),_c('div',{staticClass:"blacklist-tips"},[_c('div',{staticClass:"tip-item"},[_vm._v("*释: 身份证加入黑名单池后,下次用户换号实名该身份证,提示你的身份已冻结")]),_vm._v(" "),_c('div',{staticClass:"tip-item"},[_vm._v("手机号加入黑名单池,下次用户用此手机号将无法登录,提示该账号已冻结")])])],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("提交表单\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/users-freeze-formm.d748d3d73173e0d7afd6.js